/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliUpdatePeriodDto } from '../../models/amoxcalli-update-period-dto';

export interface ApiCyclesCycleIdPeriodsPeriodIdPut$Params {
  cycleId: string;
  periodId: string;
      body?: AmoxcalliUpdatePeriodDto
}

export function apiCyclesCycleIdPeriodsPeriodIdPut(http: HttpClient, rootUrl: string, params: ApiCyclesCycleIdPeriodsPeriodIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesCycleIdPeriodsPeriodIdPut.PATH, 'put');
  if (params) {
    rb.path('cycleId', params.cycleId, {});
    rb.path('periodId', params.periodId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiCyclesCycleIdPeriodsPeriodIdPut.PATH = '/api/cycles/{cycleId}/periods/{periodId}';
